module.exports = __webpack_public_path__ + "img/userB17.ef84e05b.jpg";